import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchExistingOrders, fetchOrderByTrackingNumber, getBusinessUnit } from '../../store/APISlice';
import { setBillingInformation, setBillingPTRAInformation, setProductHandlingInformation, setReceivingInformation, setRequestorInformation, setShippingInformation } from '../../store/formSlice';
import { getUserEmail } from '../../store/OktaAuthSlice';
import { useAppDispatch } from '../../store/store';
import Footer from '../FooterComponent/Footer';
import Header from '../HeaderComponent/Header';
import UserProfile from '../userProfile/UserProfile';
import { NEW_REQUEST } from '../../constants/Constants';
import { Typography } from '@mui/material';

const ExistingOrder = () => {

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const userEmail = useSelector(getUserEmail);

  const selectedBu = useSelector(getBusinessUnit);

  const [fetchOrderDetails, setFetchOrderDetails] = useState<any[] | null>(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState<string | null>(null);

  const email = useSelector(getUserEmail);

  const description =`PTS - Existing Order Entries - ${selectedBu}`

  useEffect(() => {

    const fetchOrderDetails = async () => {

      const payload = {
        userId: userEmail,
        type: selectedBu
      }
      dispatch(fetchExistingOrders(payload)).then((res: any) => {
        setFetchOrderDetails(res.payload.data);
        setLoading(false);
      }).catch(err => {
        setError('Failed to load order details. Please try again later.');
        setLoading(false);
      })

    };

    fetchOrderDetails();
  }, [selectedBu, dispatch, userEmail]);

  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleOrderClick = (order: any) => {
    setSelectedOrder(order);
    fetchTrackingDetails(order.trackingNumber);
  };

  const fetchTrackingDetails = async (trackingNumber: any) => {

    const req = {
      "trackingNumber": trackingNumber,
      "requestType": selectedBu
    }
    dispatch(fetchOrderByTrackingNumber(req)).then((res: any) => {
      const order = res.payload.data;
      
      dispatch(setBillingInformation({
        purchaseOrder: order.purchaseOrderNumber,
        pickUpNumber: order.pickupNumber,
        purchaseOrderNumberList: order.purchaseOrderNumberList
      }))
      dispatch(setRequestorInformation({
        requesterName: order.requesterName,
        requesterEmail: order.requesterEmail,
        requesterPhoneNumber: order.requesterPhoneNumber,
        requesterAlternateContacts: order.requesterAlternateContacts
      }))
      
      dispatch(
        setShippingInformation({
          shipperCloseTime: order.shipperCloseTime,
          shippingLocationID : order.shippingLocationID,
          shippingAdditionalComments: order.shippingAdditionalComments,
          shippingCity: order.shippingCity,
          shippingCompanyName: order.shippingCompanyName,
          shippingContactEmail: order.shippingContactEmail,
          shippingContactName: order.shippingContactName,
          shippingContactPhoneNumber: order.shippingContactPhoneNumber,
          shippingDockDoor: order.shippingDockDoor,
          shippingDockHeightFlag: order.shippingDockHeightFlag,
          shippingProductReadyDate: order.shippingProductReadyDate,
          shippingProductReadyTime: order.shippingProductReadyTime,
          shippingSchedulingType: order.shippingSchedulingType,
          shippingState: order.shippingState,
          shippingStreetAddress: order.shippingStreetAddress,
          shippingZipCode: order.shippingZipCode,
          shippingAlternateContacts: order.shippingAlternateContacts
        }));
      dispatch(setReceivingInformation({
        receivingAdditionalComments: order.receivingAdditionalComments,
        receivingLocationID: order.receivingLocationID,
        receivingCity: order.receivingCity,
        receivingCloseTime: order.receivingCloseTime,
        receivingCompanyName: order.receivingCompanyName,
        receivingContactEmail: order.receivingContactEmail,
        receivingContactName: order.receivingContactName,
        receivingContactPhoneNumber: order.receivingContactPhoneNumber,
        receivingDockDoor: order.receivingDockDoor,
        receivingDockHeightFlag: order.receivingDockHeightFlag,
        receivingRequiredDate: order.receivingRequiredDate,
        receivingRequiredTime: order.receivingRequiredTime,
        receivingSchedulingType: order.receivingSchedulingType,
        receivingState: order.receivingState,
        receivingStreetAddress: order.receivingStreetAddress,
        receivingZipCode: order.receivingZipCode,
        receivingAlternateContacts: order.receivingAlternateContacts
      }));
      dispatch(
        setProductHandlingInformation({
          commodity: order.commodity,
          quantity: order.quantity,
          containerType: order.containerType,
          productDimension: order.productDimension,
          totalWeightLbs: order.totalWeightLbs,
          loadValue: order.loadValue,
          productAdditionalComments: order.productAdditionalComments,
          reeferRequired: order.reeferRequired,
          hazmatFlag: order.hazmatFlag,
          expediteServiceFlag: order.expediteServiceFlag,
          fullTruckLoadFlag: order.fullTruckLoadFlag,
          teamDeliveryFlag: order.teamDeliveryFlag,
          specialHandlingRequired: order.specialHandlingRequired,
          freightClass: order.freightClass,
          temperatureRequirement: order.temperatureRequirement,
          hazmatUnNumber: order.hazmatUnNumber,
          hazmatClass: order.hazmatClass,
          packagingGroup: order.packagingGroup,
          handlingComments: order.handlingComments,
          specialHandlingType: order.specialHandlingType,
          teamDeliveryApproverEmail: order.teamDeliveryApproverEmail,
          expediteApproverEmail: order.expediteApproverEmail,
          isLoadParcel: order.isLoadParcel,
          dedicatedTransportFlag: order.dedicatedTransportFlag,
          dedicatedApproverEmail: order.dedicatedApproverEmail,
          commodityOtherValue: order.commodityOtherValue,
          dedicatedTransportApproverEmail: order.dedicatedTransportApproverEmail
        }))
      dispatch(setBillingPTRAInformation({
        programInfo: order.programInfo,
        researchAndDevelopmentFlag: order.researchAndDevelopmentFlag,
        arlingtonOrGrandPrairieLocationFlag: order.arlingtonOrGrandPrairieLocationFlag,
        pepLoc: order.pepLoc,
        accountProjectNumber: order.accountProjectNumber,
        costCenter: order.costCenter,
        divLoc: order.divLoc,
        purchaseOrderNumber: order.purchaseOrderNumber,
        pickupNumber: order.pickupNumber,
        purchaseOrderNumberList: order.purchaseOrderNumberList
      }
      ))
      navigate(NEW_REQUEST);
    }).catch(err => {
      console.log("Failed to get the order details");
    })
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    return `${year}/${day}/${month}`;
  };

  return (
    <>
      <UserProfile />
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100vw' }}>
        <div style={{ flex: '0 1 auto', marginBottom: '20px' }}>
          <Header headDescription = {description} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
              </Box>
            ) : error ? (
              <div style={{ color: 'red' }}>{error}</div>
            ) : (
              <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
    <Typography
        variant="h6"
        sx={{
          fontFamily: 'Helvetica Neue',
          backgroundColor: '#0047ba',
          color: '#FFFFFF ', // Remove !important
          fontSize: '22px', // Responsive font size
          borderRadius: '5px',
          fontWeight: { xs: 300, sm: 500, md: 700 }, // Responsive font weight
          textAlign: 'center',
          width: '100%',
          margin: { xs: '0 20px 0 0', sm: '0 80px 0 0', md: '0 160px 0 0' }, // Responsive margin
        }}
        gutterBottom
      >
        Select Recent Requests
      </Typography>
  <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', marginTop: '0' }}>
    <table style={{
      borderCollapse: 'collapse',
      width: '100%',
      margin: '0', // Remove margin
      padding: '0', // Remove padding
    }}>
      <tbody>
        {Array.isArray(fetchOrderDetails) &&
          fetchOrderDetails?.slice(0, 15).map((order, index) => (
            <tr key={index} style={{ border: '1px solid #E5ECF8' }}>
              <td
                style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'center', cursor: 'pointer' }}
                onClick={() => handleOrderClick(order)}
              >
                {order?.shippingCity} - {order?.receivingCity} - {formatDate(order?.createdDate)}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
</div>
            )}
          </div>
        </div>
        <div style={{ flex: '0 1 auto', padding: '20px' }}>
        <Box sx={{
              position: "fixed",
              bottom: "60px", // Space above the footer
              left: { xs: '1rem', sm: '8rem' }, // Responsive left position
              width: { xs: "90%", sm: "80%" }, // Responsive width
              display: "flex",
              justifyContent: "space-between", // Left and right alignment
              alignItems: "center"
            }}>
          <Button
            variant="contained"
            style={{
              backgroundColor: '#F6EB39', color: '#2E2E38', fontFamily: 'Helvetica Neue',
              fontSize: '14px', fontWeight: 700, lineHeight: '22px', textAlign: 'left',
            }}
            onClick={() => navigate('/inbound-automation')}
          >
            Back
          </Button>
        </Box>

         {/*  <Button
            variant="contained"
            style={{
              backgroundColor: '#F6EB39', color: '#2E2E38', fontFamily: 'Helvetica Neue',
              fontSize: '14px', fontWeight: 700, lineHeight: '22px', textAlign: 'left',
            }}

            onClick={() => navigate('/inbound-automation')}
          >
            Back
          </Button> */}
        </div>
        <div style={{ flex: '0 1 auto' }}>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ExistingOrder;